export default __webpack_public_path__ + "static/media/green-map-people.f03b0e56.svg";